import React, { useEffect, useState } from "react";
import { Formik, FormikProps } from "formik";
import * as Yup from "yup";
import { wire } from "react-hot-wire";

import { CategoryService } from "../../../../services/prize/category/Category.service";
import { Category } from "../../../../models/prize/category/Category";
import Drawer from "../../../common/drawer/Drawer";

import CreateTemplate from "./Create.template";
import CircularProgress from "@material-ui/core/CircularProgress";

export type CreateCategoryFormValues = {
  name: string;
  supplierCategories: string;
};

const CreateCategorySchema = Yup.object().shape({
  name: Yup.string().required(),
  supplierCategories: Yup.string()
});

function CreateCategoryComponent({
  categoryService,
  drawerProps,
  action,
  parent
}: {
  parent?: Category;
  categoryService: CategoryService;
  drawerProps?: any;
  action?: () => void;
}) {
  const [supplierCategories, setSupplierCategories] = useState<any[]>([]);
  const [loading, setLoading] = useState<boolean>(true);

  useEffect(() => {
    if (parent) {
      (async () => {
        const supplierCategoriesList = await categoryService.getSupplierCategories();
        setSupplierCategories(supplierCategoriesList);
        setLoading(false);
      })();
    } else {
      setLoading(false);
    }
  }, [parent, categoryService]);

  if (loading) {
    return (
      <div className="d-flex align-items-center justify-content-center h-100">
        <CircularProgress color="primary" />
      </div>
    );
  }

  return (
    <Drawer
      {...drawerProps}
      render={({ close }: { close: () => void }) => (
        <Formik
          enableReinitialize
          isInitialValid={false}
          initialValues={{
            name: "",
            supplierCategories: ""
          }}
          validationSchema={CreateCategorySchema}
          onSubmit={(values: CreateCategoryFormValues) => {
            const data: any = {
              name: { pl: values.name }
            };

            if (parent) {
              data.parent = { id: parent.id };
              data.supplierCategories = values.supplierCategories
                .split(",")
                .map((s: string) => s.trim())
                .filter((s: string) => s);
            }

            return categoryService
              .create(data)
              .then(close)
              .then(action);
          }}
          render={(props: FormikProps<CreateCategoryFormValues>) => (
            <CreateTemplate
              formikProps={props}
              parent={parent}
              close={close}
              translationPath="prize.category.create"
              supplierCategories={supplierCategories}
            />
          )}
        />
      )}
    />
  );
}

export default wire(["categoryService"], CreateCategoryComponent);
